<template>
    <v-form>
        <div class="az-form-content">
            <v-container fluid white v-if="naoPossuiEsclarecimento && naoPossuiImpugnacao">
                <div class="text-info-vazio container-box">
                    <p class="text-info">Este processo <b>não possui</b> nenhum esclarecimento <br/> ou impugnação
                        <b>criados</b>
                    </p>
                </div>
            </v-container>
            <v-container fluid grid-list-xl v-else>
                <div v-if="!naoPossuiEsclarecimento">
                    <v-flex xs12 sm12 d-flex>
                        <span class="az-subtitle primary--text">Esclarecimentos</span>
                    </v-flex>
                    <detalhe-esclarecimento-impugnacao-tabela
                        v-model="esclarecimentosImpugnacoesAtualizadas.esclarecimentos"
                        :tipo="'Esclarecimento'"
                        @abrirModalRespostas="abrirModalRespostas"
                        @downloadAnexo="downloadAnexo"
                    />
                </div>

                <div v-if="!naoPossuiImpugnacao">
                    <v-flex xs12 sm12 d-flex>
                        <span class="az-subtitle primary--text">Impugnações</span>
                    </v-flex>
                    <detalhe-esclarecimento-impugnacao-tabela
                        v-model="esclarecimentosImpugnacoesAtualizadas.impugnacoes"
                        :tipo="'Impugnação'"
                        @abrirModalRespostas="abrirModalRespostas"
                        @downloadAnexo="downloadAnexo"
                    />
                </div>

                <v-spacer style="height: 40px;"></v-spacer>

                <modal-resposta-esclarecimento-impugnacao
                    v-if="modalRespostas"
                    v-model="modalRespostas"
                    :tipo="tipo"
                    :item="itemSelecionado"
                    @downloadAnexo="downloadAnexo"
                    @fecharModalRespostas="fecharModalRespostas">
                </modal-resposta-esclarecimento-impugnacao>
            </v-container>
        </div>
    </v-form>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import DetalheEsclarecimentoImpugnacaoTabela from './components/tabela/DetalheEsclarecimentoImpugnacaoTabela'
import ModalRespostaEsclarecimentoImpugnacao
    from './components/modal/resposta-esclarecimento-impugnacao/ModalRespostaEsclarecimentoImpugnacao'
import {actionTypes} from '@/commons/constants'
import _ from 'lodash'

export default {
    name: 'ConsultasDetalheEsclarecimentosImpugnacao',
    components: {
        DetalheEsclarecimentoImpugnacaoTabela,
        ModalRespostaEsclarecimentoImpugnacao
    },
    data() {
        return {
            esclarecimentosImpugnacoesAtualizadas: {},
            esclarecimentosImpugnacoesCarregados: false,
            modalRespostas: false,
            tipo: null,
            itemSelecionado: null,
        }
    },
    computed: {
        naoPossuiEsclarecimento() {
            return !(this.esclarecimentosImpugnacoesAtualizadas &&
                    this.esclarecimentosImpugnacoesAtualizadas.esclarecimentos)
                || this.esclarecimentosImpugnacoesAtualizadas.esclarecimentos.length === 0;
        },
        naoPossuiImpugnacao() {
            return !(this.esclarecimentosImpugnacoesAtualizadas &&
                    this.esclarecimentosImpugnacoesAtualizadas.impugnacoes)
                || this.esclarecimentosImpugnacoesAtualizadas.impugnacoes.length === 0;
        },
        ...mapState(['esclarecimentosImpugnacoesLicitacaoLegado'])
    },
    async mounted() {
        await this.buscarEsclarecimentosImpugnacoesLegado(this.$route.params.id)
        this.esclarecimentosImpugnacoesCarregados = true
        await this.atribuirEsclarecimentoImpugnacaoLicitacao()
    },
    methods: {
        abrirModalRespostas(respostas, tipo) {
            this.modalRespostas = true
            this.tipo = tipo
            this.itemSelecionado = respostas
        },
        async atribuirEsclarecimentoImpugnacaoLicitacao() {
            this.esclarecimentosImpugnacoesAtualizadas = _.cloneDeep(this.esclarecimentosImpugnacoesLicitacaoLegado)
        },
        async downloadAnexo(anexo) {
            await this.downloadAnexoUsiga({
                idAnexo: anexo.id,
                nomeAnexo: anexo.nome,
                tipo: anexo.tipoDocumentoUSiga
            })
        },
        fecharModalRespostas() {
            this.modalRespostas = false
            this.itemSelecionado = null
        },
        ...mapActions({
            buscarEsclarecimentosImpugnacoesLegado: actionTypes.BUSCAR_ESCLARECIMENTOS_IMPUGNACOES_LEGADO,
            downloadAnexoUsiga: actionTypes.DOWNLOAD_ANEXO_USIGA
        })
    }
}
</script>

<style scoped lang="stylus">
.text-info
    color #777 !important
    font-size 18px
    text-align center

.text-info-vazio
    display flex
    flex-direction row
    justify-content center
    align-items center

.container-box
    margin-top 20px
    width 100%
    height 300px
    border 1px solid #CCCCCC
    border-radius 5px
</style>